import { render, staticRenderFns } from "./FormularioInmobiliaria.vue?vue&type=template&id=196aa94e&scoped=true&"
import script from "./FormularioInmobiliaria.vue?vue&type=script&lang=js&"
export * from "./FormularioInmobiliaria.vue?vue&type=script&lang=js&"
import style0 from "./FormularioInmobiliaria.vue?vue&type=style&index=0&id=196aa94e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196aa94e",
  null
  
)

export default component.exports